import { Link } from "react-router-dom"
import Button from "../Button"

export type ListHeaderProps = {
  Icon?: JSX.Element
  title: string | JSX.Element
  createButtonText?: string
  disableCreateButton?: boolean
  dataTestid?: string
  operationKlassToCheckPermission?: string
  actions?: JSX.Element
}

const ListHeader = ({
  Icon,
  title,
  createButtonText,
  disableCreateButton = false,
  dataTestid,
  operationKlassToCheckPermission,
  actions,
}: ListHeaderProps) => {
  return (
    <div className="w-full flex justify-between items-center">
      {typeof title === 'string' ? (
        <div className="flex gap-2 items-center">
          {Icon}
          <h2 className="text-2xl font-bold">{title}</h2>
        </div>
      ) : (
        title
      )}
      {actions ? actions : createButtonText
        ? <Link to={disableCreateButton ? '' : 'create'} className={disableCreateButton ? 'cursor-default' : ''}>
          <Button operationKlassToCheckPermission={operationKlassToCheckPermission} className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" disabled={disableCreateButton} data-testid={dataTestid}>
            {createButtonText}
          </Button>
        </Link>
        : null
      }
    </div>
  )
}

export default ListHeader